<!-- Header de Free NAS: reemplaza al header y sidebar del layout normal -->
<nav class="free-nas-header">
  <div class="d-flex align-items-center gap-20">
    <a class="free-nas-brand" routerLink="/free-nas">
      <app-image-color
        [width]="'38px'"
        [height]="'38px'"
        [url]="'header/nas-logo-small.svg'"
        [color]="'#ffffff'"
      ></app-image-color>
    </a>

    <div class="d-flex align-items-center gap-10">
      <img
        [src]="getUserImage()"
        class="rounded-circle free-nas-avatar"
        alt="avatar"
        onerror="this.onerror=null;this.src='assets/img/dummy.png';"
      />
      <div class="d-flex flex-column free-nas-user">
        <span class="font-weight-bold">{{ getUserName() }}</span>
        <small>{{ getUserTypeKey() | translate }}</small>
      </div>
    </div>
  </div>

  <!-- Selector de granja solo cuando el cliente tiene mas de una. En mobile baja a su
       propio renglon en lugar de ocultarse, para poder cambiar de granja -->
  <div class="free-nas-farm" *ngIf="farms.length > 1">
    <select
      class="form-control form-control-sm"
      [ngModel]="farm_id"
      (change)="setFarm($event.target.value)"
    >
      <option *ngFor="let farm of farms" [value]="farm.id">{{ farm.name }}</option>
    </select>
  </div>

  <ul class="free-nas-menu">
    <li *ngFor="let item of menuItems">
      <a [routerLink]="item.link" [class.active]="isActive(item)" [title]="item.text | translate">
        <app-image-color
          [width]="'24px'"
          [height]="'24px'"
          [url]="item.svg"
          [color]="'#ffffff'"
        ></app-image-color>
        <span class="free-nas-menu-text">{{ item.text | translate }}</span>
      </a>
    </li>
    <li>
      <a class="c-pointer" [title]="'free_nas.header.logout' | translate" (click)="logout()">
        <app-image-color
          [width]="'22px'"
          [height]="'22px'"
          [url]="'menu-icons/logout.svg'"
          [color]="'#ffffff'"
        ></app-image-color>
      </a>
    </li>
  </ul>
</nav>
